import React, {Component} from 'react';
import MainMenu from '../../components/menu/MainMenu';
import { Card, Col, Row, Form, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Redirect } from 'react-router-dom'
import SimpleModal from '../../components/modal/SimpleModal';
import LoadingModal from "../../components/modal/LoadingModal";
import {getTransactionDetail} from '../../resources/API';
import {formatAccountNo} from '../../resources/Utils';
import TransactionDetailField from './components/TransactionDetailField';
import moment from 'moment';
import numeral from 'numeral';


// import NumberFormat from 'react-number-format';

class TransactionDetail extends Component {
    constructor(props) {
        super();

        this.state = {
            transactionDetail : null,
            modal :{
                header : null,
                body : null,
                footer : null,
                show : false,
                variant : 'danger'
            },
            loadingShow :false
        }
    }

    handleModalClose = () => {
        let modal = this.state.modal;
        modal.show = false;
        this.setState({modal: modal})
    }

    componentDidMount(){
        this.getData();
    }

    async getData(){
        const {transaction} = this.props.location.state;
        const {merchantProfile} = this.props;
        this.setState({loadingShow : true});
        const transactionDetailResponse = 
            await getTransactionDetail(
                merchantProfile.merchantId,
                transaction.txnNumber
                );
        if (transactionDetailResponse.status !== 200 ) {
            window.location = '/notfound';
        }
        
        this.setState({
            loadingShow : false,
            transactionDetail : transactionDetailResponse.body.transaction
        });
    }

    render() {
        const {mode, filterCriteria, role} = this.props.location.state;
        const {loadingShow, transactionDetail} = this.state;
        if (!transactionDetail) {
            return null;
        }
        if (!['online', 'scheduled'].includes(mode)){
            return <Redirect to='/notfound' />
        }
        if ((mode === 'online' && !role.includes("DD_REPORT_TRANSACTION")) ||
            (mode === 'scheduled' && !role.includes("DD_REPORT_TRANSACTION_RECURRING"))
        ) {
            return <Redirect to='/unauthorized' />
        }

        const {modal} = this.state;
        return (
            <React.Fragment>
                <Form>
                    <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
                        <Card.Body className="p-0 bg-grey">
                            <MainMenu mainMenu={"transaction"} subMenu={"all"} role={role}/>
                            <Card className="shadow mx-auto mt-4 mb-5 card-width-1200">
                                <Card.Header className="pt-3 pb-2 bg-white font-weight-bold text-scb">
                                    <Row>
                                        <Col sm={2}>
                                            Transaction Details
                                        </Col>
                                    </Row>                                
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col className="border-right">
                                            <TransactionDetailField id={"txnNumber"} fieldName={"Transaction No."} value={transactionDetail.txnNumber}/>
                                            <TransactionDetailField id={"createdDateTime"} fieldName={"Transaction Created Date/Time"} value={moment(transactionDetail.createdDateTime, "YYYYMMDDHHmmss").format("DD-MMM-YYYY HH:mm:ss")}/>
                                            <TransactionDetailField id={"updatedDateTime"} fieldName={"Transaction Date/Time"} value={moment(transactionDetail.updatedDateTime, "YYYYMMDDHHmmss").format("DD-MMM-YYYY HH:mm:ss")}/>
                                            <TransactionDetailField id={"amount"} right fieldName={"Transaction Amount (THB)"} value={numeral(transactionDetail.oriAmount).format('0,0.00')}/>
                                            <TransactionDetailField id={"merchantFeeAmount"} right fieldName={"Merchant Fee (THB)"} value={numeral(transactionDetail.merchantFeeAmount).format('0,0.00')}/>
                                            <TransactionDetailField id={"customerFeeAmount"} right fieldName={"Customer Fee (THB)"} value={numeral(transactionDetail.customerFeeAmount).format('0,0.00')}/>
                                            <TransactionDetailField id={"fineAmount"} right fieldName={"Fine Amount (THB)"} value={numeral(transactionDetail.fineAmount).format('0,0.00')}/>
                                            <TransactionDetailField id={"status"} fieldName={"Transaction Status"} value={transactionDetail.status}/>
                                            <TransactionDetailField id={"errorDescription"} fieldName={"Transaction Status Description"} value={transactionDetail.errorDescription}/>
                                            <TransactionDetailField id={"hostResponseCode"} fieldName={"Host Status Code"} value={transactionDetail.hostResponseCode}/>
                                            <TransactionDetailField id={"hostResponseDesc"} fieldName={"Host Status Description"} value={transactionDetail.hostResponseDesc}/>
                                        </Col>
                                        <Col>
                                            <TransactionDetailField id={"merchantIntegrationType"} fieldName={"Marchant Integration Type"} value={transactionDetail.merchantIntegrationType}/>
                                            <TransactionDetailField id={"paymentChannel"} fieldName={"Payment Channel"} value={transactionDetail.paymentChannel}/>
                                            <TransactionDetailField id={"merchantId"} fieldName={"Merchant ID"} value={transactionDetail.merchantId}/>
                                            <TransactionDetailField id={"merchantName"} fieldName={"Merchant Name"} value={transactionDetail.merchantName}/>
                                            <TransactionDetailField id={"subAccountId"} fieldName={"Merchant Sub-Account ID"} value={transactionDetail.subAccountId}/>
                                            <TransactionDetailField id={"toAcctNumber"} fieldName={"Merchant Account No."} value={transactionDetail.toAcctNumber}/>
                                            <TransactionDetailField id={"refNumber"} fieldName={"Merchant Reference No."} value={transactionDetail.refNumber}/>
                                            <TransactionDetailField id={"customerRef"} fieldName={"Merchant Customer No."} value={transactionDetail.customerRef}/>
                                            <TransactionDetailField id={"corpId"} fieldName={"Payer Corp ID"} value={transactionDetail.corpId}/>
                                            <TransactionDetailField id={"fromAcctNumber"} fieldName={"Payer Account Number"} value={transactionDetail.fromAcctNumber}/>
                                            {
                                             transactionDetail.actualAcctNumber? 
                                             <TransactionDetailField id={"actualAcctNumber"} fieldName={"Shadow Account Number"} value={transactionDetail.actualAcctNumber}/>:
                                             null
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={{span:3, offset:8}} className="mt-5 mb-3">
                                            <LinkContainer to={{pathname : "/reports/transactions/" + mode, state:{filterCriteria:filterCriteria}}} activeClassName="">
                                                <Button variant="outline-secondary" block>Back to Transaction Report</Button>
                                            </LinkContainer>
                                        </Col>
                                    </Row>                           
                                </Card.Body>
                            </Card>
                        </Card.Body>
                    </Card>
                </Form>
                <SimpleModal
                    modal={modal}
                    onClose={this.handleModalClose}
                />
                <LoadingModal show={loadingShow} />
            </React.Fragment>
        );
      }      
}
export default TransactionDetail;